import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-work-classification',
    templateUrl: './work-classification.component.html',
    styleUrls: ['./work-classification.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkClassificationComponent {

}
